/**
 * Argus — URL events client API + types.
 * Bloc v1.0.9 #7 — 2026-05-07.
 */

import { apiFetch } from './api';

export type UrlEventBrowser = 'chrome' | 'edge' | 'brave' | 'firefox' | 'opera';

export interface UrlEventItem {
  id: number;
  browser: UrlEventBrowser | string;
  url: string;
  title: string | null;
  visitedAt: string;
  capturedAt: string;
}

export interface UrlEventsResponse {
  agentId: string;
  items: UrlEventItem[];
  nextCursor: number | null;
  limit: number;
}

export interface UrlEventsQuery {
  browser?: string[];
  q?: string;
  from?: string;
  to?: string;
  cursor?: number;
  limit?: number;
}

export async function fetchUrlEvents(agentIdHex: string, query: UrlEventsQuery = {}): Promise<UrlEventsResponse> {
  const params = new URLSearchParams();
  if (query.browser && query.browser.length > 0) params.set('browser', query.browser.join(','));
  if (query.q) params.set('q', query.q);
  if (query.from) params.set('from', query.from);
  if (query.to) params.set('to', query.to);
  if (query.cursor) params.set('cursor', String(query.cursor));
  if (query.limit) params.set('limit', String(query.limit));
  const qs = params.toString();
  const path = `/api/v1/agents/${agentIdHex}/url-events${qs ? `?${qs}` : ''}`;
  const res = await apiFetch<UrlEventsResponse>(path);
  return res.data!;
}
